export const API_BASE_URL = process.env.REACT_APP_API_URL;

export const GET_MEMBER = `${API_BASE_URL}/member/me`;
export const FETCH_ALL_MEMBERS = `${API_BASE_URL}/member/all`;
export const SET_PASSWORD = `${API_BASE_URL}/member/set-password`;
export const RESET_PASSWORD = `${API_BASE_URL}/member/reset-password`;
export const MEMBER_LOGIN = `${API_BASE_URL}/member/login`;
export const DELETE_MEMBER = `${API_BASE_URL}/member`;
export const ENABLE_MEMBER = `${API_BASE_URL}/member`;
export const INVITE_MEMBER = `${API_BASE_URL}/member/invite`;
export const TOGGLE_MEMBER_ROLE = (memberId: string) =>
  `${API_BASE_URL}/member/${memberId}/role`;
export const UPLOAD_PDF = `${API_BASE_URL}/upload/pdf`;
export const UPLOAD_IMAGE = `${API_BASE_URL}/upload/image`;

export const FETCH_ALL_DOCUMENTS = `${API_BASE_URL}/upload/all`;
export const FETCH_SIGNED_DOCUMENTS = `${API_BASE_URL}/upload/signed-url`;
export const FETCH_SIGNED_DOCUMENT_FROM_EMAIL = (documentId: string) =>
  `${API_BASE_URL}/upload/signed-url/email?documentId=${documentId}`;

export const FETCH_ALL_REMINDERS = `${API_BASE_URL}/upload/reminders/all`;
export const SEND_REMINDER_EMAIL = (documentId: string) =>
  `${API_BASE_URL}/member/reminder/doc/${documentId}`;
export const TOGGLE_REMINDER_EMAIL_AS_RENEWED = (documentId: string) =>
  `${API_BASE_URL}/member/reminder/doc/${documentId}`;
export const DELETE_DOCUMENT = (documentId: string) =>
  `${API_BASE_URL}/member/reminder/doc/${documentId}`;
export const TOGGLE_DOCUMENT_AS_APPLIED = (documentId: string) =>
  `${API_BASE_URL}/member/reminder/doc/${documentId}/applied`;

export const GET_SETTINGS = `${API_BASE_URL}/member/settings`;
export const UPDATE_SETTINGS = `${API_BASE_URL}/member/settings`;
export const UPDATE_NOTIFICATION_SETTINGS = `${API_BASE_URL}/member/notification-settings`;

export const UPDATE_DOCUMENT = (documentId: string) =>
  `${API_BASE_URL}/upload/doc/${documentId}`;
